import { transparentize } from 'polished';
import { colors, font } from "./";
var components = {
    headings: {
        h1: {
            color: colors.lightBlack,
            fontSize: ['1.5rem', '1.875rem', '2.125rem'],
            letterSpacing: ['0.04rem', '0.05rem'],
            fontFamily: font.family.glosa,
            fontWeight: font.weight.semiBold,
            lineHeight: 1.3,
        },
        h2: {
            color: colors.lightBlack,
            fontSize: ['1.25rem', '1.5rem'],
            letterSpacing: ['0.03rem', '0.04rem'],
            fontFamily: font.family.glosa,
            fontWeight: font.weight.bold,
            lineHeight: 1.3,
        },
        h3: {
            color: colors.lightBlack,
            fontSize: ['1.125rem', '1.25rem'],
            letterSpacing: '0.05rem',
            fontFamily: font.family.proximaNova,
            fontWeight: font.weight.semiBold,
            lineHeight: 1.5,
        },
        h4: {
            color: colors.lightBlack,
            fontSize: ['1.125rem', '1.25rem'],
            letterSpacing: '0.05rem',
            fontFamily: font.family.proximaNova,
            fontWeight: font.weight.semiBold,
            lineHeight: 1.5,
        },
        h5: {
            color: colors.lightBlack,
            fontSize: ['1.125rem', '1.25rem'],
            letterSpacing: '0.05rem',
            fontFamily: font.family.proximaNova,
            fontWeight: font.weight.semiBold,
            lineHeight: 1.5,
        },
        h6: {
            color: colors.lightBlack,
            fontSize: ['1.125rem', '1.25rem'],
            letterSpacing: '0.05rem',
            fontFamily: font.family.proximaNova,
            fontWeight: font.weight.semiBold,
            lineHeight: 1.5,
        },
    },
    cards: {
        backgroundColor: colors.white,
        boxShadow: "0 2px 4px 0 " + transparentize(0.85, colors.black),
        borderRadius: '5px',
        header: {
            color: '#222',
        },
        small: {
            padding: ['2rem 1rem', '2.5rem 1.5rem'],
        },
        medium: {
            padding: ['2.5rem 1rem', '4rem', '4rem 1.5rem'],
        },
        large: {
            padding: ['2.5rem 1rem', '4rem', '4rem', '4rem 6rem'],
        },
    },
    modal: {
        padding: ['48px 16px', '64px 48px', '56px'],
    },
    markdown: {
        text: {
            color: colors.lightBlack,
            fontFamily: font.family.proximaNova,
            fontWeight: font.weight.normal,
            letterSpacing: '0.05rem',
            lineHeight: 1.5,
            fontSize: ['1rem', '1rem', '1rem', '1.125rem'],
        },
        table: {
            border: "1px solid " + colors.lighterBlack,
            padding: '0.5rem',
            fontWeight: 'bold',
            textAlign: 'center',
        },
    },
};
export default components;
//# sourceMappingURL=components.js.map